const isLocalDevelopment =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const withoutTrailingSlash = (value: string): string => value.replace(/\/+$/, "");
const withLeadingSlash = (value: string): string => (value.startsWith("/") ? value : `/${value}`);

/**
 * Versioned SimolApps platform API. Production defaults to the new Laravel
 * API; staging/local builds can override it explicitly.
 */
export const PLATFORM_API_BASE = withoutTrailingSlash(
  process.env.REACT_APP_PLATFORM_API_BASE ||
    (isLocalDevelopment ? "/v2" : "https://api.simolapps.ru/v1/platform")
);

/**
 * Older, non-v2 SimolApps endpoints which have not yet received a versioned
 * contract. Keeping the base configurable removes host literals without
 * pretending that those endpoints have already migrated.
 */
export const LEGACY_API_BASE = withoutTrailingSlash(
  process.env.REACT_APP_LEGACY_API_BASE || (isLocalDevelopment ? "/api" : "")
);

export function platformApiUrl(path: string): string {
  return `${PLATFORM_API_BASE}${withLeadingSlash(path)}`;
}

export function legacyApiUrl(path: string): string {
  if (!LEGACY_API_BASE) {
    throw new Error("Legacy SimolApps API is disabled in this build");
  }
  return `${LEGACY_API_BASE}${withLeadingSlash(path)}`;
}
